module.exports = __webpack_public_path__ + "img/pantalla_perder.c2716fc5.png";